import { Box, Paper, Typography } from "@mui/material";
import { useState } from "react";
import type { DayLine } from "../utils/dayHourGrid";
import { DayHourHeader } from "./DayHourHeader";
import { DayHourRow } from "./DayHourRow";

type Props = {
	title: string;
	lines: DayLine[];
	dateKey: string;
	tz: string;
	nowMs: number | null;
	nowHour: number | null;
	hoveredRunKey: string | null;
	onRunHover: (key: string | null) => void;
	onLineClick: (slug: string) => void;
};

export const DayBoard = ({
	title,
	lines,
	dateKey,
	tz,
	nowMs,
	nowHour,
	hoveredRunKey,
	onRunHover,
	onLineClick,
}: Props) => {
	const [hoveredHour, setHoveredHour] = useState<number | null>(null);

	return (
		<Paper sx={{ p: 2 }}>
			<Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
				{title}
			</Typography>
			<Box sx={{ overflowX: "auto" }}>
				<Box
					sx={{
						minWidth: 900,
						borderRadius: 2,
						overflow: "hidden",
						border: "1px solid #0F172A0F",
						boxShadow: "0 1px 3px #0F172A0A, 0 8px 24px -8px #0F172A14",
					}}
				>
					<DayHourHeader
						nowHour={nowHour}
						hoveredHour={hoveredHour}
						onHourHover={setHoveredHour}
					/>
					{lines.map((line) => (
						<DayHourRow
							key={line.assetId}
							{...line}
							dateKey={dateKey}
							tz={tz}
							nowMs={nowMs}
							nowHour={nowHour}
							hoveredHour={hoveredHour}
							onHourHover={setHoveredHour}
							hoveredRunKey={hoveredRunKey}
							onRunHover={onRunHover}
							onLineClick={onLineClick}
						/>
					))}
				</Box>
			</Box>
		</Paper>
	);
};
